import { Spin, } from 'antd'

const Loading = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',  // 水平居中
      alignItems: 'center',        // 垂直居中
      height: '100%',             // 占满视口高度
      width: '100%'
    }}>
      <Spin tip="加载中..." size="large" >
        <div style={{
          padding: 50,
          background: 'rgba(0, 0, 0, 0.05)',
          borderRadius: 4,
        }} />
      </Spin>
    </div>
  )
}

export default Loading
